module.exports = __webpack_public_path__ + "img/3.1.3.629031d4.png";